// extracted by mini-css-extract-plugin
export default {"content__container":"Content_content__container__I7LnB","content__header":"Content_content__header__3XGwf","content__body":"Content_content__body__MM00A"};